import { useMutation, useQueryClient } from "@tanstack/react-query"
import { makeCreateKnowledgeBase } from "../../domain/use-cases/create-knowledge-base"
import { httpKnowledgeBaseRepository } from "../../data/repositories/knowledge-base-repository"
import type { CreateKnowledgeBaseInput } from "../../domain/entities/knowledge-base"

const createKnowledgeBase = makeCreateKnowledgeBase(httpKnowledgeBaseRepository)

export const useCreateKnowledgeBase = () => {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (input: CreateKnowledgeBaseInput) => createKnowledgeBase(input),
    onSuccess: () =>
      void qc.invalidateQueries({
        queryKey: ["knowledge-bases"],
        refetchType: "all",
      }),
  })
}
